import { render, staticRenderFns } from "./AppointmentsCalendar.vue?vue&type=template&id=65036e24&scoped=true&"
import script from "./AppointmentsCalendar.vue?vue&type=script&lang=js&"
export * from "./AppointmentsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsCalendar.vue?vue&type=style&index=0&id=65036e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65036e24",
  null
  
)

export default component.exports